import { render, staticRenderFns } from "./AddressImageMapPay.vue?vue&type=template&id=3ec2a70a&scoped=true"
import script from "./AddressImageMapPay.vue?vue&type=script&lang=js"
export * from "./AddressImageMapPay.vue?vue&type=script&lang=js"
import style0 from "./AddressImageMapPay.vue?vue&type=style&index=0&id=3ec2a70a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec2a70a",
  null
  
)

export default component.exports